<ng-container *ngIf="profileField$ | async as profileField">
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="labelIcons"></sh-field-label>
    </dt>
    <ng-container *ngIf="listValues$ | async as values; else emptyData">
        <dd class="sh-description-list__details" *ngIf="values.length > 0; else emptyData">
            <ng-container *ngIf="childDefinition">
                <ng-container [ngSwitch]="childDefinition?.Type">
                    <ng-container *ngSwitchCase="FieldType.EnumField">
                        <ng-container *ngTemplateOutlet="labelList; context: { values: values, childDefinition: childDefinition }"></ng-container>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                        <ng-container *ngTemplateOutlet="tagList; context: { values: values, childDefinition: childDefinition }"></ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </dd>
    </ng-container>
</ng-container>

<ng-template #labelList let-values="values" let-childDefinition="childDefinition">
    <ng-container
        *ngTemplateOutlet="
            canSearchOnClick(childDefinition) ? searchableListItems : nonSearchableListItems;
            context: { values: values, childDefinition: childDefinition }
        "
    ></ng-container>
</ng-template>

<ng-template #searchableListItems let-values="values" let-childDefinition="childDefinition">
    <span *ngFor="let option of values; let index = index">
        <a class="sh-link" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(childDefinition, option.value)">{{ option.label }}</a>
        <ng-container *ngIf="index < values.length - 1">, </ng-container>
    </span>
</ng-template>

<ng-template #nonSearchableListItems let-values="values">
    <span *ngFor="let option of values; let index = index">
        {{ option.label }}
        <ng-container *ngIf="index < values.length - 1">, </ng-container>
    </span>
</ng-template>

<ng-template #tagList let-values="values" let-childDefinition="childDefinition">
    <ul class="sh-tag-list sh-clear-margin-top">
        <ng-container
            *ngTemplateOutlet="
                canSearchOnClick(childDefinition) ? searchableTags : nonSearchableTags;
                context: { values: values, childDefinition: childDefinition }
            "
        ></ng-container>
    </ul>
</ng-template>

<ng-template #searchableTags let-values="values" let-childDefinition="childDefinition">
    <a class="sh-tag--link sh-tag-list__item" *ngFor="let keyword of values" [title]="keyword.label">
        <span class="sh-tag__label" [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(childDefinition, keyword.value)">{{
            keyword.label
        }}</span>
    </a>
</ng-template>

<ng-template #nonSearchableTags let-values="values" let-childDefinition="childDefinition">
    <ng-container *ngFor="let keyword of values">
        <ng-container [ngSwitch]="childDefinition?.Type">
            <ng-container *ngSwitchCase="FieldType.UrlField">
                <a class="sh-tag--link sh-tag-list__item" [href]="keyword.value" target="_blank" rel="noopener noreferrer" [title]="keyword.label">
                    <span class="sh-tag__label">{{ keyword.label }}</span>
                </a>
            </ng-container>

            <ng-container *ngSwitchDefault>
                <li class="sh-tag--readonly sh-tag-list__item" [title]="keyword.label">
                    <span class="sh-tag__label">{{ keyword.label }}</span>
                </li>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
